import marketData from '../../data/market-flow.json'
import type { MarketFlowData } from '../types/market'
import { JsonMarketDataProvider } from './JsonMarketDataProvider'

export const marketDataProvider = new JsonMarketDataProvider(marketData as MarketFlowData)
